import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, useHistory, type RouteProps } from 'react-router';

import { entityReset } from '@uncinc/react-drupal-core';

import { ROUTE_ACCOUNT_LOGIN } from '../../config/routes';
import useLoggedInStatus from '../../hooks/useLoggedInstatus';

export interface CustomRouteProps extends RouteProps {
  privateRoute?: boolean;
}

const CustomRoute: React.FC<CustomRouteProps> = ({ privateRoute, ...props }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoggedIn } = useLoggedInStatus();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => {
    dispatch(entityReset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (privateRoute && isLoggedIn === false) {
    history.push(ROUTE_ACCOUNT_LOGIN);
  }

  return (
    <Route {...props} />
  );
};

export default CustomRoute;
